import { Component, ElementRef, Input, Renderer2, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import hljs, { HighlightResult } from 'highlight.js';
import { NpHljsUtils } from './np-hljs-utils';
import { CommonModule } from '@angular/common';

export const NpHljsLanguage = hljs.listLanguages();

@Component({
  selector: 'np-hljs',
  template: `<pre *ngIf="result"><code class="hljs" [innerHTML]="result"></code></pre>`,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule]
})
export class NpHljsComponent {

  init: boolean = false;

  @Input('lang')
  lang!: string | null;

  @Input('code')
  code!: string | null;

  @Input('lineOpts')
  lineOpts: {
    enable?: boolean;
    startFrom?: number,
    singleLine?: boolean;
  } = { enable: true, startFrom: 1, singleLine: true };

  result!: any;
  resultLang!: string | undefined;

  constructor(private _ngEl: ElementRef, private _renderer: Renderer2, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.doHighlight();
    this.init = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.init && (changes['code'] || changes['lang'])) {
      this.doHighlight();
    }
  }

  doHighlight() {

    if (!this.code) {
      this.result = '';
      this.resultLang = '';
      return;
    }

    let code = this.code;

    let highlightResult: HighlightResult;

    if (this.lang && hljs.getLanguage(this.lang)) {
      highlightResult = hljs.highlight(code, { language: this.lang });
    } else {
      highlightResult = hljs.highlightAuto(code);
    }

    this.resultLang = highlightResult.language;

    let result: any;
    if (this.lineOpts?.enable) {
      result = NpHljsUtils.lineNumbersValue(highlightResult.value, this.lineOpts);
    } else {
      result = highlightResult.value;
    }

    this.result = this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
